import moment from 'moment'

export function prepPosts({ posts: providedPosts }) {
	let ps = providedPosts.slice(0) // clone, sort is in-place

	// Sort posts before making Immutable.Seq()
	//   -1 === a before b
	//    1 === b before a
	//    0 === equal
	ps.sort(postSorter)

	return ps
}

export function postSorter(a, b) {
	// check weights
	if (a.weight < b.weight) {
		return 1
	} else if (a.weight > b.weight) {
		return -1
	} else {

		// compare dates
		const ma = moment(a.post_date)
		const mb = moment(b.post_date)

		if (mb < ma) {
			return -1
		} else if (mb > ma) {
			return 1
		}
	}
	return 0
}

export function postFilter(filters, p) {
	return Object.keys(filters).every( filter => {
		if (!filters[filter]) return true;
		if (p[filter].indexOf) {
			return p[filter].indexOf(filters[filter]) !== -1
		}
		return p[filter] === filters[filter]
	})
}



// WEBPACK FOOTER //
// ./js/website/utils/CategoryFilterPostFunctions.js